<div class="container download_section pad_btm_size">

  <div>
      <div class="card m-3">
          <h5 class="card-header" style="font-size: 21px; color: #fff; background-color: #2955a9;">
             Direct NIMI Payment Done Not Update Detail
          </h5>
          <div class="card-body" style="padding-top: 0px;">
              <div class="row">

                  <div class="col-md-12 status_tag" style="text-align: left;">
                      <!--table-->
                      <table>
                          <tr>
                              <th>Ticket Id</th>
                              <td> {{this.ticketId}} </td>
                          </tr>
                          <tr>
                              <th> Grievance date</th>
                              <td> {{this.entrydate}} </td>
                          </tr>
                          <tr>
                              <th>State</th>
                              <td>{{this.state}} </td>
                          </tr>


                          <tr>
                              <th>Name</th>
                              <td>{{this.name}} </td>
                          </tr>
                          <tr>
                              <th>Email</th>
                              <td>{{this.email}} </td>
                          </tr>
                          <tr>
                              <th>Mobile No</th>
                              <td>{{this.mobileno}} </td>
                          </tr>

                          <tr>
                              <th>Payment Date</th>
                              <td>{{this.date}} </td>
                          </tr>



                          <tr>
                              <th>Bulk Register Number</th>
                              <td>
                                  {{this.bulkregno}}
                              </td>
                          </tr>

                          <tr>
                            <th>Payment Method</th>
                            <td>
                                {{this.paymethod}}
                            </td>
                        </tr>
                        <tr>
                          <th>UTR / Transcation Number</th>
                          <td>
                              {{this.utr}}
                          </td>
                      </tr>
                      <tr>
                        <th>Associated Mobile Number</th>
                        <td>
                            {{this.ascmob}}
                        </td>
                    </tr>
                    <tr>
                      <th>Scan Copy Of Chellan</th>
                      <td>
                        <!-- <img class="upload_cls" src="http://localhost:5001/{{this.upload}}"> -->
                        <img class="upload_cls" src="https://grsnodetest.nimiquestionbank.in/{{this.upload}}">
                        <!-- <img style="width: 20px;" src="https://grsnodetest.nimiquestionbank.in/{{element.upload}}"> -->
                      </td>
                  </tr>


                          <!-- <tr>
                      <th>trade</th>
                      <td>{{this.trade}} </td>
                  </tr> -->


                          <tr>
                              <th>Number Of Student</th>
                              <td>{{this.numberofstud}} </td>
                          </tr>
                          <tr>
                              <th>Amount</th>
                              <td>{{this.amount}} </td>
                          </tr>
                          <tr>
                              <th>Additional Description</th>
                              <td>{{this.descreption}} </td>
                          </tr>


                          <tr>
                              <th>Admin Status</th>
                              <td>{{this.admin_status}} </td>
                          </tr>
                          <tr>
                              <th>Admin Status Description</th>
                              <td>{{this.admin_status_desc}} </td>
                          </tr>



                      </table>
                  </div>

                  <hr>


              </div>


          </div>
      </div>
  </div>

</div>


<style>
  .banner_header {
      background: #2955a9;
      padding: 10px 0px;
      text-align: left;
      color: #fff;
      margin: 0px;
  }

  .banner_header h2 {
      font-size: 21px;
  }
</style>
